export default __webpack_public_path__ + "static/media/article1.2d092027.jpg";